@import 'common/component';
@import 'forms/reset/button';

:host {
  display: block;
}

:host([type="box"]:not(:first-of-type)) {
  margin-top: $spacing-3;
}

:host([type='compact']:first-of-type) {
  border-top: 1px solid var(--o2-border-primary, #{$border-primary});
}

.accordion {
  transition-timing-function: var(--o2-transition);
  transition-duration: 0.2s;
  transition-property: all;
  background: var(--o2-background-main-primary, #{$background-main-primary});

  &:focus-visible {
    outline: 0;
  }

  &.accordion--open {
    .accordion__icon {
      o2-icon {
        transform: rotate(180deg);
      }
    }

    .accordion__heading,
    slot[name='heading'] {
      -webkit-box-orient: initial;
      -webkit-line-clamp: initial;
      overflow: visible;
      text-overflow: clip;
      white-space: normal
    }

    .accordion__content {
      color: var(--o2-main-text-primary, #{$text-main-primary});
      font-size: 1.6rem;
      font-style: normal;
      @include font-weight(400);
      line-height: 1.3;
      padding: 1.6rem 1.6rem 2.4rem 1.6rem;
      visibility: visible;
      overflow: visible;
      opacity: 1;
      max-height: 100%;
      transition: all 0.25s ease-in-out;
    }
  }
}

.accordion__header {
  font-family: unset;
  background: transparent;
  position: relative;
  padding: 1rem 1.6rem;
  transition: 0.2s ease;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  gap: $spacing-4;
  border: 0;
  appearance: none;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  text-align: left;

  &:focus-visible {
    @include focus-visible();
    z-index: 1;
  }

  &:hover {
    background: $background-main-hover;
  }

  .accordion__header-left,
  .accordion__header-right {
    display: flex;
    gap: $spacing-4;
  }

  .accordion__header-left {
    padding: 0.2rem 0;
    overflow: hidden;

    ::slotted(o2-status) {
      padding: 0.4rem 0;
    }

    ::slotted(o2-tooltip) {
      padding: 0.4rem 0;
      height: 0;
    }
  }

  .accordion__header-inner {
    overflow: hidden;
    display: flex;
    gap: $spacing-3;
    flex-grow: 1;

    ::slotted(o2-icon) {
      padding: 0.2rem 0
    }
  }

  .accordion__heading,
  slot[name='heading'] {
    color: var(--o2-main-text-primary, #{$text-main-primary});
    padding: 0.15rem 0;
    font-size: 1.6rem;
    font-style: normal;
    @include font-weight(600);
    line-height: 1.3;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;

    @media (min-width: 768px) {
      display: initial;
      -webkit-box-orient: initial;
      -webkit-line-clamp: initial;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .accordion__tag {
    flex-grow: 1;
  }

  .accordion__heading-right {
    color: var(--o2-main-text-primary, #{$text-main-primary});
    padding: 0.35rem 0;
    font-size: 1.6rem;
    font-style: normal;
    @include font-weight(600);
    line-height: 1.3;
    white-space: nowrap;
  }

  .accordion__icon {
    transition-timing-function: var(--o2-transition);
    transition-duration: 0.2s;
    line-height: 1;
    flex-shrink: 0;
    min-width: 2.8rem;
    height: 2.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border-radius: $radius-xs;
    cursor: pointer;
  }
}

.accordion__content {
  padding: 0 1.6rem;
  visibility: hidden;
  overflow: hidden;
  opacity: 0;
  max-height: 0;
  transition: all 0.15s ease-out;
}

.accordion--compact {
  border-bottom: 1px solid var(--o2-border-primary, #{$border-primary});
}

.accordion--box {
  border-radius: $radius-xs;

  &:not(.accordion--open) {
    .accordion__header {
      border-radius: $radius-xs;

      &:hover {
        border-radius: $radius-xs;
      }
    }
  }

  &.accordion--open {
    .accordion__header {
      border-top-left-radius: $radius-xs;
      border-top-right-radius: $radius-xs;

      &:hover {
        border-top-left-radius: $radius-xs;
        border-top-right-radius: $radius-xs;
      }
    }
  }
}
